import { render, staticRenderFns } from "./AdDetailBag.vue?vue&type=template&id=3a26284c&scoped=true&"
import script from "./AdDetailBag.vue?vue&type=script&lang=js&"
export * from "./AdDetailBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a26284c",
  null
  
)

export default component.exports